import * as Yup from "yup";

import { EMAIL_REGEX } from "utils/constants";

export const validationSchema = Yup.object({
  email: Yup.string().required("Please fill out this field.").matches(EMAIL_REGEX, "Invalid email format."),
});
